/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CSSProperties, createElement } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import cx from 'clsx';

import ListItem from '@/components/ListItem';
import { CollaborationProcessItem } from '@/config/collaboration-process.config';

import styles from './CollaborationProcessCard.module.scss';

interface CollaborationProcessCardProps {
  item: CollaborationProcessItem;
  t: any;
  tRaw: any;
  reverse?: boolean;
  style?: CSSProperties;
}

const CollaborationProcessCard = ({ item, t, tRaw, reverse, style }: CollaborationProcessCardProps) => (
  <Box className={cx(styles.container, { [styles.reverse]: reverse })} style={style}>
    <Box className={styles.imageWrapper}>{createElement(item.icon, { props: {} })}</Box>
    <Stack gap={4} className={styles.content}>
      <Typography variant="h5" component="h3" sx={{ typography: { md: 'h4' } }}>
        {t(item.title as any)}
      </Typography>
      <Stack gap={3}>
        {(tRaw(item.features as any) as string[]).map((feature, featureIndex) => (
          <ListItem key={featureIndex} text={feature} variant={item.bulletColor} />
        ))}
      </Stack>
    </Stack>
  </Box>
);

export default CollaborationProcessCard;
